// Firebase web config: set via REACT_APP_* (local .env or Netlify build env).
// These are public client values (safe in the browser); protect data with Firebase rules.

function requiredEnv(name) {
  const value = process.env[name];
  if (!value) {
    throw new Error(
      `Missing ${name}. Set it in apps/solvtax-ui/.env or Netlify site env (see .env-template).`
    );
  }
  return value;
}

export const firebaseConfig = {
  apiKey: requiredEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: requiredEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: requiredEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: requiredEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: requiredEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: requiredEnv("REACT_APP_FIREBASE_APP_ID"),
  // Optional (Analytics)
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID }
    : {}),
};
